import React from 'react'
import AceHandyMan from '../../assets/images/clients/AceHandyMan.png'
import Luxottica from '../../assets/images/clients/Luxottica.png'
import PaintingWithATwist from '../../assets/images/clients/PaintingWithATwist.png'
import PremiumServiceBrands from '../../assets/images/clients/PremiumServiceBrands.png'
import SylvanLearning from '../../assets/images/clients/SylvanLearning.png'
// import TLG from '../../assets/images/clients/TLG.png'
// import Unleashed from '../../assets/images/clients/Unleashed.png'
import WellBiz from '../../assets/images/clients/WellBiz.png'
import WorkOutAnytime from '../../assets/images/clients/WorkOutAnytime.png'
import Xponential from '../../assets/images/clients/Xponential.png'
import Regis from '../../assets/images/clients/Regis.png'
import MasterCard from '../../assets/images/clients/MasterCard.png'
import HandAndStoneAlt from '../../assets/images/clients/HandAndStoneAlt.png'
import UberGray from '../../assets/images/clients/UberGray.png'
import TlgGray from '../../assets/images/clients/TlgGray.png'
import UnleashedBrands from '../../assets/images/clients/UnleashedBrands.png'
import EuropeanWaxCenter from '../../assets/images/clients/EuropeanWaxCenter.png'
import Vetcor from '../../assets/images/clients/Vetcor.png'
import Evive from '../../assets/images/clients/EviveBrands.png'
import MySalonSuite from '../../assets/images/clients/MySalonSuite.png'
import TCBY from '../../assets/images/clients/TCBY.png'
import MrsFields from '../../assets/images/clients/MrsFields.png'
import HealthSource from '../../assets/images/clients/HealthSource.png'
import UFCGym from '../../assets/images/clients/UFCGym.png'
import PickleBall from '../../assets/images/clients/PickleBall.png'
import Blaze from '../../assets/images/clients/Blaze.png'
import RealityOne from '../../assets/images/clients/RealityOne.png'
import FamousBrands from '../../assets/images/clients/FamousBrands.png'
import Kumon from '../../assets/images/clients/Kumon.png'
import ImageSliderV2 from './ImageSliderV2'
// import RBC from '../../assets/images/clients/RBC.png'
// import UPS from '../../assets/images/clients/UPS.png'
// import Uber from '../../assets/images/clients/Uber.png'
// import Yeb from '../../assets/images/clients/Yeb.png'

const PartnerSlider = () => {
    const imageArray = [
        { src: WorkOutAnytime, alt: 'Workout Anytime' },
        { src: PaintingWithATwist, alt: 'Painting With a Twist' },
        { src: Luxottica, alt: 'Luxottica' },
        { src: MasterCard, alt: 'Master Card'},
        { src: EuropeanWaxCenter, alt: 'European Wax Center'},
        { src: PremiumServiceBrands, alt: 'Premium Service Brands' },
        { src: UnleashedBrands, alt: 'Unleashed Brands' },
        { src: WellBiz, alt: 'Wellbiz' },
        { src: AceHandyMan, alt: 'Ace Handy Man' },
        { src: SylvanLearning, alt: 'Sylvan Learning' },
        { src: HandAndStoneAlt, alt: 'Hand & Stone'},
        { src: Regis, alt: 'Regis' },
        { src: UberGray, alt: 'Uber'},
        { src: Xponential, alt: 'Xponential Fitness' },
        { src: TlgGray, alt: 'The Little Gym' },
        { src: Vetcor, alt: 'Vetcor'},
        { src: UFCGym, alt: 'UFC Gym'},
        { src: RealityOne, alt: 'Reality ONE Group'},
        { src: Kumon, alt: 'Kumon'},
        { src: FamousBrands, alt: 'Famous Brands'},
        { src: MrsFields, alt: 'Mrs Fields'},
        { src: HealthSource, alt: 'Health Source'},
        { src: Evive, alt: 'Evive Brands'},
        { src: TCBY, alt: 'TCBY'},
        { src: MySalonSuite, alt: 'My Salon Suite'},
        { src: Blaze, alt: 'Blaze Pizza'},
        { src: PickleBall, alt: 'Pickle Ball'},
    ]

    // const imageArray = [
    //     { src: SylvanLearning, alt: 'Sylvan Learning' },
    //     { src: AceHandyMan, alt: 'Ace Handy Man' },
    //     { src: WorkOutAnytime, alt: 'Workout Anytime' },
    //     { src: Luxottica, alt: 'Luxottica' },
    //     { src: PaintingWithATwist, alt: 'Painting With a Twist' },
    //     { src: Regis, alt: 'Regis' },
    //     { src: PremiumServiceBrands, alt: 'Premium Service Brands' },
    //     { src: RBC, alt: 'Royal Bank of Canada' },
    //     { src: TLG, alt: 'The Little Gym' },
    //     { src: Uber, alt: 'Uber' },
    //     { src: Unleashed, alt: 'Unleashed Brands' },
    //     { src: WellBiz, alt: 'Wellbiz' },
    //     { src: Xponential, alt: 'Xponential Fitness' },
    //     { src: UPS, alt: 'UPS' },
    //     { src: Yeb, alt: 'Youth Enrichment Brands' }
    // ]


    return (
        <div className={`py-8 flex flex-col items-center`}>
            <ImageSliderV2 images={imageArray} imageRules='h-[44px] max-w-none' />
        </div>
    )
}

export default PartnerSlider